const ocxVideoPlay = ({ url, progress, error, el}) => {
    let player = document.getElementById(el);

    try {
        if (player.playlist.isPlaying) {
            player.playlist.stop();
        }
        player.playlist.clear();
        player.playlist.add(url);
        player.video.aspectRatio = "16:9";
        player.playlist.play();
        registerVLCEvent("MediaPlayerBuffering", handle_MediaPlayerBuffering);
        registerVLCEvent("MediaPlayerOpening", function() {
            console.log("正在加载资源");
        });
    } catch (err) {
        console.log("error",err)
        error && error();
    }

    //注册事件
    function registerVLCEvent(event, handler) {
        if (player.attachEvent) {
            if (player.attachEvent) {
                player.attachEvent(event, handler);
            } else if (this.vlcplayer.addEventListener) {
                player.addEventListener(event, handler, false);
            } else {
                player["onloadeddata"] = handler;
            }
        }
    }

    function handle_MediaPlayerBuffering(val) {
        console.log("缓冲：" + val + "%");
        progress && progress(val);
    }
};


export { ocxVideoPlay };
